import styled from 'styled-components';

import Heading from 'components/_core/Heading';
import Text from 'components/_core/Text';
import ButtonBadge from 'components/ButtonBadge';

export const BackButton = styled(ButtonBadge).attrs({
  icon: 'arrow-left',
})`
  flex: 0;
  min-height: ${({ theme }) => theme.spacings.abs32}px;
  align-self: flex-start;
`;

export const Body = styled(Text).attrs({
  size: 'sm',
})`
  display: block;
`;

export const Title = styled(Heading).attrs({
  size: 'lg',
})`
  display: block;
  margin-bottom: ${({ theme }) => theme.spacings.abs16}px;
`;
